module.exports = __webpack_public_path__ + "static/media/flower_pastel_pink_frame_background-removebg-preview_1573299909415.c61a93e4.png";